import { render, staticRenderFns } from "./Pergola.vue?vue&type=template&id=6d5ab5f7&scoped=true"
import script from "./Pergola.vue?vue&type=script&lang=ts"
export * from "./Pergola.vue?vue&type=script&lang=ts"
import style0 from "./Pergola.vue?vue&type=style&index=0&id=6d5ab5f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5ab5f7",
  null
  
)

export default component.exports